// IndexedDB-backed Repo via idb-keyval. Used in the browser.
// Snapshots are stored as JSON strings to keep things portable: the engine's
// snapshot() returns plain data, but IndexedDB structured cloning can choke
// on rarer values (Maps, undefined-in-arrays) — JSON sidesteps the question.

import { createStore, del, get, set, type UseStore } from 'idb-keyval';
import { fromJSON, toJSON, type Snapshot } from '@biz-kid/engine';
import type { Repo, SaveKey } from './repo.js';

const DEFAULT_DB = 'biz-kid';
const DEFAULT_STORE = 'snapshots';

export class IndexedDBRepo implements Repo {
  private readonly store: UseStore;

  constructor(dbName: string = DEFAULT_DB, storeName: string = DEFAULT_STORE) {
    this.store = createStore(dbName, storeName);
  }

  async getSnapshot(key: SaveKey): Promise<Snapshot | null> {
    const raw = await get<string>(key, this.store);
    if (!raw) return null;
    const parsed = fromJSON(raw);
    if (!parsed.ok) return null;
    return parsed.snapshot;
  }

  async putSnapshot(key: SaveKey, snap: Snapshot): Promise<void> {
    await set(key, toJSON(snap), this.store);
  }

  async clearSnapshot(key: SaveKey): Promise<void> {
    await del(key, this.store);
  }
}
